import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export const useAdverts = ({ position_key, ad_format, states_id, category_id, useWebContent = false }) => {
  const normalizedStateId = Number(states_id || 0);
  const normalizedCategoryId = Number(category_id || 0);

  return useQuery({
    queryKey: ['adverts', useWebContent ? 'web-content' : 'default', position_key || '', ad_format || '', normalizedStateId, normalizedCategoryId],
    queryFn: async () => {
      const endpoint = useWebContent ? '/web-content/get-adverts' : '/adverts';
      const response = await api.get(endpoint, {
        params: {
          ...(position_key ? { position_key } : {}),
          ...(normalizedStateId > 0 ? { states_id: normalizedStateId } : {}),
          ...(normalizedCategoryId > 0 ? { category_id: normalizedCategoryId } : {}),
          ...(ad_format ? { ad_format } : {}),
        },
      });
      return response.data;
    },
    staleTime: 3 * 60 * 1000,
    cacheTime: 3 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 3,
    enabled: Boolean(ad_format && (position_key || normalizedStateId > 0 || normalizedCategoryId > 0)),
  });
};
